/** @jsx jsx */

import { Fragment as _ } from 'react';
import { css, jsx } from '@emotion/core';
import { renderToString } from 'react-dom/server';

export const Clouds = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 415 242"
    preserveAspectRatio="xMidYMid slice"
    fill="none"
  >
    <g id="Clouds" clipPath="url(#clip0_870_927)">
      <path
        id="Vector"
        d="M0.000823975 242L414.826 242V0L0.000823975 0V242Z"
        fill={color}
      />
      <path
        id="Vector_2"
        opacity="0.3"
        d="M74.82 158.681C68.589 158.681 62.888 160.954 58.503 164.717C58.491 164.727 58.431 164.778 58.399 164.807C58.397 164.809 58.296 164.398 58.276 164.314C54.494 148.409 40.194 136.58 23.132 136.58C14.33 136.58 6.267 139.731 0 144.963L0 200.444C6.267 205.675 14.33 208.827 23.132 208.827L74.821 208.827C88.668 208.827 99.893 197.602 99.893 183.754C99.893 169.906 88.668 158.682 74.821 158.682L74.82 158.681Z"
        fill="white"
      >
        <animate
          attributeName="d"
          values="M74.82 158.681C68.589 158.681 62.888 160.954 58.503 164.717C58.491 164.727 58.431 164.778 58.399 164.807C58.397 164.809 58.296 164.398 58.276 164.314C54.494 148.409 40.194 136.58 23.132 136.58C14.33 136.58 6.267 139.731 0 144.963L0 200.444C6.267 205.675 14.33 208.827 23.132 208.827L74.821 208.827C88.668 208.827 99.893 197.602 99.893 183.754C99.893 169.906 88.668 158.682 74.821 158.682L74.82 158.681Z;M58.82 158.681C52.589 158.681 46.888 160.954 42.503 164.717C42.491 164.727 42.431 164.778 42.399 164.807C42.397 164.809 42.296 164.398 42.276 164.314C38.494 148.409 24.194 136.58 7.13199 136.58C-1.67001 136.58 -9.733 139.731 -16 144.963L-16 200.444C-9.733 205.675 -1.67001 208.827 7.13199 208.827L58.821 208.827C72.668 208.827 83.893 197.602 83.893 183.754C83.893 169.906 72.668 158.682 58.821 158.682L58.82 158.681Z;M74.82 158.681C68.589 158.681 62.888 160.954 58.503 164.717C58.491 164.727 58.431 164.778 58.399 164.807C58.397 164.809 58.296 164.398 58.276 164.314C54.494 148.409 40.194 136.58 23.132 136.58C14.33 136.58 6.267 139.731 0 144.963L0 200.444C6.267 205.675 14.33 208.827 23.132 208.827L74.821 208.827C88.668 208.827 99.893 197.602 99.893 183.754C99.893 169.906 88.668 158.682 74.821 158.682L74.82 158.681Z"
          begin="0s"
          dur="8s"
          repeatCount="indefinite"
          fill="freeze"
          calcMode="linear"
          keyTimes="0;0.5;1"
        />
      </path>
      <path
        id="Vector_3"
        opacity="0.3"
        d="M360.192 124.189C350.465 124.189 342.314 130.932 340.157 139.999C340.146 140.047 340.087 140.281 340.087 140.281C340.068 140.264 340.034 140.235 340.027 140.229C337.527 138.084 334.277 136.788 330.725 136.788C322.831 136.788 316.432 143.187 316.432 151.081C316.432 158.975 322.831 165.374 330.725 165.374L360.192 165.374C371.565 165.374 380.785 156.154 380.785 144.781C380.785 133.408 371.565 124.188 360.192 124.188L360.192 124.189Z"
        fill="white"
      >
        <animate
          attributeName="d"
          values="M360.192 124.189C350.465 124.189 342.314 130.932 340.157 139.999C340.146 140.047 340.087 140.281 340.087 140.281C340.068 140.264 340.034 140.235 340.027 140.229C337.527 138.084 334.277 136.788 330.725 136.788C322.831 136.788 316.432 143.187 316.432 151.081C316.432 158.975 322.831 165.374 330.725 165.374L360.192 165.374C371.565 165.374 380.785 156.154 380.785 144.781C380.785 133.408 371.565 124.188 360.192 124.188L360.192 124.189Z;M375.76 127.001C366.033 127.001 357.882 133.745 355.725 142.812C355.714 142.86 355.655 143.093 355.655 143.093C355.636 143.076 355.602 143.047 355.595 143.041C353.095 140.896 349.845 139.6 346.293 139.6C338.399 139.6 332 145.999 332 153.893C332 161.787 338.399 168.186 346.293 168.186L375.76 168.186C387.133 168.186 396.353 158.966 396.353 147.593C396.353 136.22 387.133 127 375.76 127L375.76 127.001Z;M360.192 124.189C350.465 124.189 342.314 130.932 340.157 139.999C340.146 140.047 340.087 140.281 340.087 140.281C340.068 140.264 340.034 140.235 340.027 140.229C337.527 138.084 334.277 136.788 330.725 136.788C322.831 136.788 316.432 143.187 316.432 151.081C316.432 158.975 322.831 165.374 330.725 165.374L360.192 165.374C371.565 165.374 380.785 156.154 380.785 144.781C380.785 133.408 371.565 124.188 360.192 124.188L360.192 124.189Z"
          begin="0s"
          dur="8s"
          repeatCount="indefinite"
          fill="freeze"
          calcMode="linear"
          keyTimes="0;0.5;1"
        />
      </path>
      <path
        id="Vector_4"
        opacity="0.3"
        d="M406.725 61.137C406.714 61.147 406.653 61.198 406.621 61.227C406.619 61.229 406.517 60.818 406.497 60.734C402.715 44.829 388.415 33 371.353 33C351.403 33 335.23 49.173 335.23 69.123C335.23 89.073 351.403 105.246 371.353 105.246L414.942 105.246L414.942 56.444C411.898 57.483 409.115 59.087 406.725 61.137Z"
        fill="white"
      >
        <animate
          attributeName="d"
          values="M406.725 61.137C406.714 61.147 406.653 61.198 406.621 61.227C406.619 61.229 406.517 60.818 406.497 60.734C402.715 44.829 388.415 33 371.353 33C351.403 33 335.23 49.173 335.23 69.123C335.23 89.073 351.403 105.246 371.353 105.246L414.942 105.246L414.942 56.444C411.898 57.483 409.115 59.087 406.725 61.137Z;M411.547 59.8201C411.536 59.8304 411.473 59.8826 411.44 59.9123C411.438 59.9143 411.333 59.4934 411.313 59.4073C407.422 43.1162 392.712 31 375.16 31C354.637 31 338 47.5657 338 68C338 88.4344 354.637 105 375.16 105L420 105L420 55.0132C416.869 56.0774 414.006 57.7203 411.547 59.8201Z;M406.725 61.137C406.714 61.147 406.653 61.198 406.621 61.227C406.619 61.229 406.517 60.818 406.497 60.734C402.715 44.829 388.415 33 371.353 33C351.403 33 335.23 49.173 335.23 69.123C335.23 89.073 351.403 105.246 371.353 105.246L414.942 105.246L414.942 56.444C411.898 57.483 409.115 59.087 406.725 61.137Z"
          begin="0s"
          dur="8s"
          repeatCount="indefinite"
          fill="freeze"
          calcMode="linear"
          keyTimes="0;0.5;1"
        />
      </path>
    </g>
    <defs>
      <clipPath id="clip0_870_927">
        <rect width="415" height="242" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const cloudsSVGToString = color =>
  renderToString(<Clouds color={color} />);
